module.exports = __webpack_public_path__ + "img/bonus_symbol_1.6ddfd87b.png";